import { IInspectionRouteGroup } from "pages/thermography/model/inspection-route-group.model";
import { TreeAdapter } from "../../components/InspectionRouteTree/mappers/genericTreeMapper";
import { IInspectionRouteGroupEquipment } from "pages/thermography/model/inspection-route-group-equipment.model";
import { TreeNodeType } from "pages/thermography/components/InspectionRouteTree/types/treeNode";

export const inspectionRouteAdapter: TreeAdapter<IInspectionRouteGroup, IInspectionRouteGroupEquipment> = {
    getId: g => g.id ?? undefined,
    getName: g => g.name ?? null,
    getCode: g => g.code ?? null,
    getIncluded: g => g.included ?? true,
    getOrderIndex: g => g.orderIndex ?? 0,

    getSubGroups: g => g.subGroups ?? [],
    getEquipments: g => g.equipments ?? [],

    getEquipmentOrder: eq => eq.orderIndex ?? 0,

    equipmentToNode: (eq, parentId) => ({
        id: eq.id ?? "",
        type: TreeNodeType.ELEMENT,
        parentId,
        name: eq.equipment?.name ?? null,
        code: eq.equipment?.code ?? null,
        title:
            eq.equipment?.name && eq.equipment?.code
                ? `${eq.equipment.name} (${eq.equipment.code})`
                : eq.equipment?.name ?? eq.equipment?.code ?? "Equipamento",

        included: eq.included ?? true,
        orderIndex: eq.orderIndex ?? 0,
        children: []
    })
};

